import goodsApi from '@/api/masterData/goods.js';
import BASE_API from '@/api/dataBase';
export default {
  data() {
    return {
      action: goodsApi.GOODS_ATTR_IMPORT,
      companyList: [],
      departmentList: [],
    };
  },
  computed: {
    token() {
      return {
        access_token: this.userInfo.access_token,
        companyCode: this.userInfo.companyCode,
        companyName: this.userInfo.companyName,
        departmentCode: this.userInfo.departmentCode,
        departmentName: this.userInfo.departmentName,
        tenantCode: this.userInfo.tenantCode,
      };
    },
    topColumn() {
      return [
        {
          prop: 'companyCode',
          name: '公司',
          type: 'select',
          options: this.companyList,
          changeMethod: 'changeMethod',
        },
        {
          prop: 'departmentCode',
          name: '部门',
          type: 'select',
          options: this.departmentList,
        },
        {
          prop: 'name',
          name: '名称',
          type: 'input',
        },
      ];
    },
  },
  mounted() {
    this.getCompanyList();
  },
  methods: {
    async changeMethod({ val, prop }) {
      console.log(val, prop);
      if (prop == 'companyCode') {
        this.query.departmentCode = null;
        this.department(val);
      }
    },
    // 获取表格数据
    async getData(attrType) {
      const postData = {
        ...this.query,
        pageNum: this.$refs.siruiTable?.page.pageNum,
        pageSize: this.$refs.siruiTable?.page.pageSize,
        attrType,
      };
      this.loading = true;
      const { data } = await this.$axios.post(goodsApi.GOODS_ATTR_PAGE, postData);
      if (data.code == 0) {
        this.tableData = data.data.records;
        this.$refs.siruiTable.setPageTotal(data.data.total);
      } else {
        this.$message.error(data.msg);
        this.tableData = [];
      }
      this.loading = false;
    },
    add(attrType) {
      this.$refs.addDialogRef.openDialog('add', attrType);
    },
    // 编辑
    edit(attrType) {
      let selectedList = this.$refs.siruiTable.getCheckboxRecords();
      if (!selectedList.length || selectedList.length != 1) {
        this.$message.error('请选择一行操作');
        return;
      }
      let id = selectedList[0].id;
      this.$refs.addDialogRef.openDialog('edit', attrType, id);
    },
    // 删除
    deleteHandler() {
      let selectedList = this.$refs.siruiTable.getCheckboxRecords();
      if (!selectedList.length) {
        this.$message.warning('请选择行操作');
        return;
      }
      this.$confirm('确定要删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const postData = [];
          selectedList.map((item) => {
            postData.push(+item.id);
          });
          const { data } = await this.$axios.post(goodsApi.GOODS_ATTR_DELETE, {
            ids: postData,
          });
          if (data.code === 0) {
            this.$message.success('删除成功');
            this.resetCheckbox();
            this.getTableData();
          } else {
            this.$message.error(`${data.msg}`);
          }
        })
        .catch(() => {});
    },
    // 更改状态
    async changeStatus(status) {
      let selectedList = this.$refs.siruiTable.getCheckboxRecords();
      if (!selectedList.length) {
        this.$message.warning('请选择行操作');
        return;
      }
      let isStatus = selectedList.find((item) => item.attrStatus == status);
      if (isStatus) {
        this.$message.warning('选中列中包含不满足的状态');
        return;
      }
      let postData = {};
      let ids = [];
      selectedList.map((item) => {
        ids.push(+item.id);
      });
      postData = {
        ids,
        attrStatus: status,
      };
      this.loading = true;
      let result = await this.$axios.post(goodsApi.GOODS_ATTR_CHANGESTATUS, postData);
      console.log('状态更改成功', result);
      if (result.data.code == 0) {
        this.resetCheckbox();
        this.$message.success(result.data.msg);
      } else {
        this.$message.error(result.data.msg);
      }
      this.loading = false;
      this.getTableData();
    },
    resetCheckbox() {
      this.$refs.siruiTable.clearCheckboxReserve();
      this.multipleSelection = [];
    },
    // 重置
    resetBtnClick() {
      this.$refs.siruiTable.setPageNum(1);
      this.$refs.siruiTable.setPageSize(10);
      this.$refs.siruiTable.clearCheckboxReserve();
      this.getTableData();
    },
    // 搜索
    search() {
      this.$refs.siruiTable.setPageNum(1);
      this.$refs.siruiTable.clearCheckboxReserve();
      this.getTableData();
    },
    // 获取列
    getColumn(defaultTableColumn) {
      this.getColumnList(defaultTableColumn).then(() => {
        this.columnList = defaultTableColumn;
      });
    },
    //获取菜单按钮
    getButtonList() {
      this.getButtons().then((e) => {
        this.menuButtonList = e || [];
        this.getColumnInfo();
      });
    },
    // 表格上面的按钮
    chooseClick(type) {
      this[type]();
    },
    // 修改每页条数
    handleSizeChange() {
      this.$refs.siruiTable.setPageNum(1);
      this.getTableData();
    },
    // 修改当前页
    handleCurrentChange() {
      this.getTableData();
    },
    // 表格选择行
    handleSelectionChange(row) {
      console.log(row);
      this.multipleSelection = row;
    },
    async getCompanyList() {
      const params = {
        id: this.userInfo.userCode,
        userCode: this.userInfo.userCode,
        personName: this.userInfo.userName,
        // personCompanyCode: this.userInfo.companyCode,
      };
      const res = await this.$axios.post(BASE_API.GET_PERSON_API, params);
      // console.log(res.data.data.personDepartmentInfo,'personDepartmentInfo');
      this.companyList = res.data.data?.personCompanyInfo.map((item) => {
        return {
          ...item,
          value: item.personCompanyCode,
          label: item.personCompanyName,
        };
      });
      if (this.query.companyCode) {
        this.department(this.form.companyCode);
      }
    },
    // 获取部门
    department(contractCompanyNo) {
      let params = {
        id: this.userInfo.userCode,
        userCode: this.userInfo.userCode,
        personName: this.userInfo.userName,
        personCompanyCode: contractCompanyNo,
      };
      this.$axios.post(BASE_API.GET_PERSON_API, params).then((res) => {
        if (res.data.code === 0) {
          this.departmentList = res.data.data.personDepartmentInfo || [];
          if (this.departmentList.length)
            this.departmentList = this.departmentList.map((item) => {
              return {
                ...item,
                value: item.personDepartmentCode,
                label: item.personDepartmentName,
              };
            });
          console.log('获取部门', this.departmentList);
        } else {
          this.$alert(res.data.msg);
        }
      });
    },
  },
};
